import { printToLetter } from "../lib/utils";

export function createPlateLayout(container) {
    const rows = container.rows;
    const cols = container.columns;

    // Create first level array of rows, initial each column array for every row
    const rowArray = new Array(rows).fill([]);

    // Fill in the cells based on number of columns
    const layout = rowArray.map((notInUse, rowIndex) => {
        const letter = printToLetter(rowIndex + 1);
        const colArray = [];
        if (!(rows === 1 && cols === 1)) {
            for (let colIndex = 0; colIndex < cols; colIndex++) {
                colArray.push({
                    row: rowIndex,
                    col: colIndex,
                    id: `${letter}${Number(colIndex + 1)
                        .toString()
                        .padStart(2, "0")}`,
                });
            }
        }
        return colArray;
    });

    return layout;
}

export function findAvailableWell(container, plateArray, packingDirection) {
    for (const plate of plateArray) {
        if (!packingDirection || packingDirection === "vertical") {
            for (let column = 0; column < container.columns; column++) {
                for (let row = 0; row < container.rows; row++) {
                    const well = plate.layout[row][column];
                    if (!well.condition && !well.isBlank) {
                        return { well, plate };
                    }
                }
            }
        } else {
            for (let row = 0; row < container.rows; row++) {
                for (let column = 0; column < container.columns; column++) {
                    const well = plate.layout[row][column];
                    if (!well.condition && !well.isBlank) {
                        return { well, plate };
                    }
                }
            }
        }
    }
    return {};
}
